<template>
	<div class="form__group form__group--photo" v-if="count < maxFiles" :class='{"form__group--loading": loading}'>
		<span>Vyfotit objekt</span>
		<input type="file" name="file">
		<label>
			<file-upload
					v-model="files"
					ref="upload"
					:post-action="postAction"
					:data="data"
					:size="maxSize"
					:extensions="extensions"
					:accept="accept"
					@input-file="inputFile"
			>
				<button type="button" class="camera"
						@click.prevent="inputFile"
						@input-file="inputFile">
					Fotoaparát
				</button>
			</file-upload>

		</label>
	</div>
</template>

<script>
	import FileUpload from 'vue-upload-component';
	import {Helper}   from '../../helper';
	import {fileInput}   from './mixins/fileInput';

	export default {
		name:       'file-input',
		components: {
			FileUpload
		},
		mixins:[fileInput],
	};
</script>

<style>
</style>
